// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"f8e10937","213":"fc380db4","337":"57a33da2","455":"bbb916f2","512":"a09cd2ea","585":"f1276e3c","735":"fb310c0c","836":"e582f9ed","840":"6574e713","857":"684de902","885":"3977cef0","890":"bced6b30"}[chunkId] + ".chunk.js";
};